import React from "react";
import { FieldValue as BaseFieldValue } from "@td/ui";
import styles from "./styles.module.scss";

const FieldValue = React.memo((props) => (
  <BaseFieldValue
    {...props}
    className={styles.fieldValue}
  />
));

FieldValue.displayName = "FieldValue";

export default FieldValue;
